<template>
  <div class="d-flex flex-column flex-column-fluid bundle">
    <!-- Toolbar -->
    <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
      <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
          <h1 class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
            منصة أكاديميا Academia
          </h1>
          <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
            <li class="breadcrumb-item text-muted">
              <a href="../../demo1/dist/index.html" class="text-muted text-hover-primary">الصفحة الرئيسية</a>
            </li>
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <li class="breadcrumb-item text-muted">تفاصيل الدورة</li>
          </ul>
        </div>
      </div>
    </div>
    <!-- Content -->
    <div v-if="loading" class="loader">
      جاري التحميل
      <div class="spinner-border text-success" role="status">
        <span class="sr-only"></span>
      </div>
    </div>
    <div v-else id="kt_app_content" class="app-content flex-column-fluid">
      <div id="kt_app_content_container" class="app-container container-fluid">
        <div class="row g-5 g-xl-10 mb-5 mb-xl-10">
          <div class="card">
            <div class="card-body p-lg-17">
              <!--begin::Hero-->
              <div class="position-relative mb-17">
                <!--begin::Overlay-->
                <div class="overlay overlay-show">
                  <div class="m-1 blog__card--thumbnail">
                    <img class="rounded" :src="`${courseDetails.bundle.imagepath}`" alt="Course Thumbnail" />
                  </div>

                  <div class="overlay-layer rounded bg-black" style="opacity: 0.4"></div>
                </div>
                <!--end::Overlay-->
                <!--begin::Heading-->
                <div class="position-absolute text-white mb-8 ms-10 bottom-0">
                  <!--begin::Title-->
                  <h3 class="text-white fs-2qx fw-bold mb-3">
                    {{ courseDetails.bundle.title }}
                  </h3>
                  <div class="fs-5 fw-semibold">
                    {{ courseDetails.bundle.detail }}
                  </div>
                  <!--end::Title-->
                </div>
                <!--end::Heading-->
              </div>
              <!--end::Hero-->

              <!--begin::Position-->
              <div class="mb-9">
                <button class="btn btn-success addtocart float-end"
                  @click="addToCart(courseDetails.bundle.id, $event, 'bundle')">
                  إضافة إلى السلة <i class="fas fa-cart-plus"></i>
                </button>
                <!--begin::Info heading-->
                <div class="fw-bold m-3 float-end">
                  <template v-if="courseDetails.bundle.discount_price">
                    <h1 class="text-dark">
                      {{ courseDetails.bundle.discount_price }} د.ل
                    </h1>
                    <span class="text-muted text-decoration-line-through">{{ courseDetails.bundle.price }} د.ل</span>
                    <span class="text-success">
                      ({{
                        calculateDiscountPercentage(
                          courseDetails.bundle.price,
                          courseDetails.bundle.discount_price
                        )
                      }}% تخفيض)
                    </span>
                  </template>
                  <template v-else>
                    <h1 class="text-success">
                      {{ courseDetails.bundle.price }} د.ل
                    </h1>
                  </template>
                </div>
                <!--end::Info heading-->
                <div class="badge badge-lg badge-light d-inline">
                  أخر تحديث: {{ courseDetails.bundle.updated_at }}
                </div>
                <a href="#" data-bs-toggle="modal" data-bs-target="#share-modal" style="
                    font-weight: 800;
                    font-size: 10px;
                    color: #07c232;
                    background-color: #89898929;
                  " class="badge badge-light m-2">
                  <i class="bi bi-share fs-3 text-white m-1" style="color: #07c232 !important"><span
                      class="path1"></span><span class="path2"></span></i>
                  مشاركة في التطبيق
                </a>
                <a href="#" data-bs-toggle="modal" data-bs-target="#share-web-modal" style="
                    font-weight: 800;
                    font-size: 10px;
                    color: white;
                    background-color: #06a23fc4;
                  " class="badge badge-light m-2">
                  <i class="bi bi-share fs-3 text-white m-1"><span class="path1"></span><span class="path2"></span></i>
                  مشاركة في الموقع
                </a>
              </div>
              <!--end::Position-->
            </div>
          </div>
        </div>

        <div class="d-flex flex-column flex-lg-row">
          <!-- Sidebar -->
          <div class="flex-column flex-lg-row-auto w-lg-250px w-xl-350px mb-10">
            <div class="card mb-5 mb-xl-8">
              <div class="card-body">
                <!--begin::Summary-->
                <div class="d-flex flex-center flex-column py-5">
                  <!--begin::Avatar-->
                  <div class="symbol symbol-100px symbol-circle mb-7">
                    <img :src="`${baseUrl}/images/user_img/${courseDetails.bundle.user_image}`" alt="image" />
                  </div>
                  <!--end::Avatar-->
                  <!--begin::Name-->
                  <a href="#" class="fs-3 text-gray-800 text-hover-primary fw-bold mb-3">
                    {{ courseDetails.bundle.user }}
                  </a>
                  <!--end::Name-->
                </div>
                <!--end::Summary-->
              </div>
            </div>
          </div>
          <!-- Content -->
          <div class="flex-lg-row-fluid ms-lg-15">
            <!-- Tabs -->
            <ul class="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semibold mb-8">
              <li class="nav-item">
                <a class="nav-link text-active-primary pb-4 active" data-bs-toggle="tab" href="#kt_overview_tab">نبذة
                  عامة</a>
              </li>
              <li class="nav-item">
                <a class="nav-link text-active-primary pb-4" data-bs-toggle="tab"
                  href="#kt_user_view_overview_tab">محتوى
                  الباقة</a>
              </li>
            </ul>
            <!-- Tab content -->
            <div class="tab-content">
              <div class="tab-pane fade show active" id="kt_overview_tab" role="tabpanel">
                <div class="card pt-4 mb-6 mb-xl-9">
                  <div class="card-header border-0"></div>
                  <div class="card-body pt-0 pb-5">
                    <!-- Course Content Summary -->
                    <div class="mt-n20 position-relative">
                      <div class="row g-3 g-lg-6">
                        <div class="col-6">
                          <div class="bg-gray-100 bg-opacity-70 rounded-2 px-6 py-5">
                            <div class="m-0 text-center">
                              <i class="fa fa-book-open fs-3qx m-5" style="color: #27ae60"></i>
                              <span class="text-gray-700 fw-bolder d-block fs-2qx lh-1 ls-n1 mb-1">{{
                                courseDetails.bundle.course_id.length
                              }}</span>
                              <span class="text-gray-500 fw-semibold fs-6">عدد الدورات</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="bg-gray-100 bg-opacity-70 rounded-2 px-6 py-5">
                            <div class="m-0 text-center">
                              <i class="fa fa-user fs-3qx m-5" style="color: #27ae60"></i>

                              <span class="text-gray-700 fw-bolder d-block fs-2qx lh-1 ls-n1 mb-1">{{
                                courseDetails.bundle.user
                                }}</span>
                              <span class="text-gray-500 fw-semibold fs-6">الأستاذ المحاضر</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- End of Summary -->
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" id="kt_user_view_overview_tab" role="tabpanel">
                <div class="card pt-4 mb-6 mb-xl-9">
                  <div class="card-body pt-0 pb-5">
                    <div class="row">
                      <div v-if="
                        courseDetails.bundle.course.length === 0 &&
                        !isLoadingCourses
                      " class="col-12">
                        <div style="
                            border-radius: 20px;
                            padding: 10px;
                            color: #000;
                            background: #ffceaa;
                            margin: 20px;
                            text-align: center;
                          ">
                          <b style="font-size: 23px">لايوجد دورات في هذا التخصص</b><br />
                          <i style="font-size: 120px" class="mdi mdi-alert-rhombus-outline"></i>
                        </div>
                      </div>
                      <div v-for="course in courseDetails.bundle.course" :key="course.id"
                        class="col-xl-3 col-lg-3 col-md-3 bundle-card">
                        <div class="card text-center">
                          <div class="card-body">
                            <div class="m-1 blog__card--thumbnail">
                              <img class="rounded" :src="`${baseUrl}/images/course/${course.image}`"
                                alt="Course Thumbnail" />
                            </div>
                            <h5 class="mt-3">
                              <a class="text-success" :href="`/course-details?id=${course.id}`">{{ course.title }}</a>
                            </h5>

                            <div class="mt-2">
                              <h3>
                                <sup><small>د.ل</small></sup>
                                {{ course.price || "__" }}
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Container End -->
    </div>
  </div>
  <ShareModal />
</template>

<script>
import { baseUrl, apiUrl } from "@/utils/api"; // Adjust the import path according to your project structure
import { showCart, addToCart } from "@/utils/cart";
import ShareModal from "./share.vue";
import Swal from "sweetalert2";

export default {
  name: "BundleDetails",
  components: {
    ShareModal,
  },
  data() {
    return {
      token: localStorage.getItem("access_token"),
      baseUrl: baseUrl, // Adjust as per your .env configuration
      courseId: this.$route.query.id,
      courseDetails: {
        category: "",
        user: "",
        user_image: "",
        title: "",
        detail: "",
        price: "",
        discount_price: "",
        course_id: [],
        imagepath: "",
      },
      loading: true, // Add loading state
    };
  },
  mounted() {
    this.fetchCourseDetails();
  },
  methods: {
    calculateDiscountPercentage(price, discountPrice) {
      if (price > 0) {
        return Math.round(((price - discountPrice) / price) * 100);
      }
      return 0;
    },
    async fetchCourseDetails() {
      try {
        const response = await fetch(
          `${apiUrl}/bundle/courses/v2/${this.courseId}?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.token}`,
            },
          }
        );
        if (!response.ok) {
          throw new Error("Failed to fetch course details");
        }
        const responseData = await response.json();
        this.courseDetails = responseData;
        //this.courseclass = responseData.course.courseclass.length; // Store all course details
        let shareModal = document.getElementById("share-content");

        shareModal.innerHTML = `
  <div style="text-align:right">
      تطبيق اكاديميا📚📱<br><br>
      ${responseData.bundle.title}<br><br>
      <a href="https://instructor.academia.ly/bundle/?id=${responseData.bundle.id}" target="_blank">https://instructor.academia.ly/bundle/?id=${responseData.bundle.id}</a><br><br>
      لتواصل و الاستفسار يرجـى التواصل على 0913103064 تليغرام
  </div>
  <div id="copyButton" class="mt-3 btn-sm btn btn-success">نسخ للمشاركة <i class="fa fa-copy"></i></div>
`;

        document
          .getElementById("copyButton")
          .addEventListener("click", async function () {
            // Define the text to be copied
            const textToCopy = `تطبيق اكاديميا📚📱\n\n${responseData.bundle.title}\n\nhttps://instructor.academia.ly/bundle/?id=${responseData.bundle.id}\n\nلتواصل و الاستفسار يرجـى التواصل على 0913103064 تليغرام`;

            try {
              // Use the Clipboard API to copy the text
              await navigator.clipboard.writeText(textToCopy);
              // Optionally, show a confirmation message
              Swal.fire({
                icon: "success",
                title: "تمت المشاركة بنجاح",
                text: "",
                confirmButtonText: "حسناً",
              });
            } catch (err) {
              console.error("فشل النسخ:", err);
              alert("فشل في نسخ النص. يرجى المحاولة مرة أخرى.");
            }
          });
        let shareWebModal = document.getElementById("share-web-content");

        shareWebModal.innerHTML = `
        <div style="text-align:right">
            تطبيق اكاديميا📚📱<br><br>
            ${responseData.bundle.title}<br><br>
            <a href="https://student.academia.ly/bundle-details?id=${responseData.bundle.id}" target="_blank">https://student.academia.ly/bundle-details?id=${responseData.bundle.id}</a><br><br>
            لتواصل و الاستفسار يرجـى التواصل على 0913103064 تليغرام
        </div>
        <div id="copyButtonWeb" class="mt-3 btn-sm btn btn-success">نسخ للمشاركة <i class="fa fa-copy"></i></div>
      `;

        document
          .getElementById("copyButtonWeb")
          .addEventListener("click", async function () {
            // Define the text to be copied
            const textToCopy = `تطبيق اكاديميا📚📱\n\n${responseData.bundle.title}\n\nhttps://student.academia.ly/bundle-details?id=${responseData.bundle.id}\n\nلتواصل و الاستفسار يرجـى التواصل على 0913103064 تليغرام`;

            try {
              // Use the Clipboard API to copy the text
              await navigator.clipboard.writeText(textToCopy);
              // Optionally, show a confirmation message
              Swal.fire({
                icon: "success",
                title: "تمت المشاركة بنجاح",
                text: "",
                confirmButtonText: "حسناً",
              });
            } catch (err) {
              console.error("فشل النسخ:", err);
              alert("فشل في نسخ النص. يرجى المحاولة مرة أخرى.");
            }
          }); // Assign the entire response data
        setTimeout(function () {
          //$('#course-background').attr('style',`background-image :url('${responseData.bundle.imagepath}')`);
        }, 2000); // 2000 milliseconds = 2 seconds

        this.loading = false; // Update loading state
      } catch (error) {
        console.error("Error fetching course details:", error);
      }
    },
    addToCart,
  },
};
</script>

<style scoped>
.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 1.5rem;
}
</style>
